import React from 'react'

export const Footer = () => {
  return (
    <div className='footer-container'>&copy;{new Date().getFullYear()} Ekam Group</div>
  )
}
